<header class="modal-header">
  <label class="h3">{{terminos.titulo}}</label>
  <button type="button" class="close" aria-label="Close" (click)="dismiss()">
    <span class="text-info" aria-hidden="true">&times;</span>
  </button>
</header>
<section class="modal-body pl-5 pr-5 pb-5">
  <p class="text-muted" [innerHTML]="terminos.descripcion"></p>
  <button class="btn btn-primary" (click)="confirm()">Aceptar</button>
</section>
